import { Routes, CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { HomeComponent } from './pages/home/home.component';
import { ReservationsComponent } from './pages/reservations/reservations.component';
import { CheckinComponent } from './pages/checkin/checkin.component';
import { P2830Component } from './pages/reservations/buildings/p28-30/p28-30.component';
import { P2820Component } from './pages/reservations/buildings/p28-20/p28-20.component';
import { P28LKComponent } from './pages/reservations/buildings/p28-lk/p28-lk.component';
import { P34Component } from './pages/reservations/buildings/p34/p34.component';
import { P35Component } from './pages/reservations/buildings/p35/p35.component';
import { HistoryComponent } from './pages/history/history.component';
import { MsalGuard } from '@azure/msal-angular';
import { AuthService } from './core/services/application/util/oauth/auth.service';

const adminGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAdmin() ? true : router.createUrlTree(['/home']);
};

export const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'reservation',
    component: ReservationsComponent,
    canActivate: [MsalGuard],
    children: [
      { path: '1', component: P35Component },
      { path: '2', component: P2830Component },
      { path: '10', component: P2820Component },
      { path: '12', component: P28LKComponent },
      { path: '23', component: P34Component },
      { path: '**', redirectTo: '' }
    ]
  },
  {
    path: 'admin',
    component: ReservationsComponent,
    canActivate: [MsalGuard, adminGuard],
    children: [
      { path: '1', component: P35Component },
      { path: '2', component: P2830Component },
      { path: '10', component: P2820Component },
      { path: '12', component: P28LKComponent },
      { path: '23', component: P34Component },
      { path: '**', redirectTo: '' }
    ]
  },
  {
    path: 'checkin',
    component: CheckinComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'history',
    component: HistoryComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    redirectTo: '/home'
  }
];